// Paywall and parental gate (a sum)
import { SFX } from '../core/audio';
import { t } from '../core/i18n';
import { $ } from './dom';
import { I, setI } from './icons';
import { openParent } from './parent-panel';

// ---------- Paywall ----------
export function openLock() {
  $('#lockBig').innerHTML = I.lock.replace('<svg viewBox="0 0 32 32">', '').replace('</svg>', '');
  $('#lockBig').setAttribute('viewBox', '0 0 32 32');
  $('#lockAdult').innerHTML = `<span class="gatelabel" style="color:inherit">${I.adult}${t('gate.adults')}</span>`;
  $('#ovLock').hidden = false;
}
setI($('#lockClose'), 'close');
$('#lockClose').addEventListener('click', () => { SFX.play('click'); $('#ovLock').hidden = true; });
$('#lockAdult').addEventListener('click', () => { $('#ovLock').hidden = true; openGate(); });

// ---------- Parents' corner: long press at the top left ----------
let holdT: ReturnType<typeof setTimeout> | undefined;
const corner = $('#corner');
corner.addEventListener('pointerdown', e => { e.preventDefault(); corner.classList.add('hold'); holdT = setTimeout(() => { corner.classList.remove('hold'); openGate(); }, 1500); });
['pointerup', 'pointerleave', 'pointercancel'].forEach(ev => corner.addEventListener(ev, () => { clearTimeout(holdT); corner.classList.remove('hold'); }));

function openGate() {
  const a = 3 + Math.floor(Math.random() * 7), b = 4 + Math.floor(Math.random() * 6), ans = a * b;
  $('#gateLabel').innerHTML = I.adult + t('gate.help');
  $('#gateQ').textContent = `${a} × ${b}`;
  const opts = new Set([ans]); while (opts.size < 4) opts.add(ans + (Math.floor(Math.random() * 9) - 4) * (Math.random() < .5 ? 1 : a));
  const arr = [...opts].filter(v => v > 0); while (arr.length < 4) arr.push(ans + arr.length * 3);
  arr.sort(() => Math.random() - .5);
  const box = $('#gateA'); box.innerHTML = '';
  arr.slice(0, 4).forEach(v => {
    const bt = document.createElement('button'); bt.textContent = String(v);
    bt.addEventListener('click', () => { $('#ovGate').hidden = true; if (v === ans) openParent(); else SFX.play('nope'); });
    box.appendChild(bt);
  });
  $('#ovGate').hidden = false;
}
setI($('#gateClose'), 'close');
$('#gateClose').addEventListener('click', () => { $('#ovGate').hidden = true; });
